import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AssistantPopoverService } from '../../../../common/assistant-popover.service';
import { ValidationService } from '../../../../common/validation.service';
import { ValueListsService } from '../../../../common/value-lists.service';
import { ValueListItem } from '../../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-kind',
  templateUrl: './kind.component.html',
  styleUrls: ['./kind.component.scss']
})
export class KindComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private formSub: Subscription;
  private geschlechtListItemsSub: Subscription;
  private staatsangehoerigkeitListItemsSub: Subscription;


  geschlechtListItems: ValueListItem[];
  staatsangehoerigkeitListItems: ValueListItem[];

  @Input()
  deletable: boolean;

  @Input()
  childIndex: number;

  @Output()
  delete = new EventEmitter<void>();

  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      familienname: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.familienname')],
      vorname: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.vorname')],
      geschlecht: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.geschlecht')],
      geburtsort: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.geburtsort')],
      geburtsdatum: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.geburtsdatum')],
      wohnort: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.wohnort')],
      staatsangehoerigkeit1: [null, this.validationService.getValidators('antragsteller.personendaten.kinder.kindListe.staatsangehoerigkeitListe', false, false, true)],
      staatsangehoerigkeit2: [null, []],
      staatsangehoerigkeit3: [null, []]
    }));
  }

  ngOnInit() {
    super.ngOnInit();

    this.geschlechtListItemsSub = this.valueListsService.getValueListItems('geschlecht')
      .subscribe((listItems: ValueListItem[]) => this.geschlechtListItems = listItems);

    this.staatsangehoerigkeitListItemsSub = this.valueListsService.getValueListItems('staatsangehoerigkeit')
      .subscribe((listItems: ValueListItem[]) => this.staatsangehoerigkeitListItems = listItems);

    this.formSub = this.form.valueChanges.subscribe(value => {
      this.compress( 'staatsangehoerigkeit');
    });




    // dies brauchen wir, damit die Elternkomponente den Validierungsstatus mitbekommt
    this.form.get('familienname').updateValueAndValidity({emitEvent: true});
    this.form.get('vorname').updateValueAndValidity({emitEvent: true});
    this.form.get('geschlecht').updateValueAndValidity({emitEvent: true});
    this.form.get('geburtsort').updateValueAndValidity({emitEvent: true});
    this.form.get('wohnort').updateValueAndValidity({emitEvent: true});
    this.form.get('staatsangehoerigkeit1').updateValueAndValidity({emitEvent: true});
  }

  ngOnDestroy(): void {
    this.formSub.unsubscribe();

    this.geschlechtListItemsSub.unsubscribe();
    this.staatsangehoerigkeitListItemsSub.unsubscribe();
  }

  triggerDelete() {
    this.delete.emit();
  }

  getUniqueSuffix(): string {
    return '_' + this.childIndex;
  }
}
